import * as types from "../action-types";
import { getToken } from "@/utils/auth";
const initUserInfo = {
  name: "",
  role: "",
  token: getToken(),
  needPassword: false,
};
export default function user(state = initUserInfo, action) {
  switch (action.type) {
    case types.USER_SET_USER_TOKEN:
      return {
        ...state,
        token: action.token
      };
    case types.USER_SET_USER_INFO:
      return {
        ...state,
        id: action.id || action._id,
        _id: action._id || action.id,
        name: action.name,
        role: action.role,
        needPassword: action.needPassword,
      };
    case types.USER_RESET_USER:
      return {};
    default:
      return state;
  }
}
